import { Subscription } from 'rxjs';
import { Directive, Input, OnDestroy } from '@angular/core';
import { Record } from "@common/data-models/records/record"; 
import { TimeoutQueue } from '@common/services/timeout-queue';
import { EnpsSubscriber } from '@common/utils/enps-subscriber';
import { ElementRef } from '@angular/core';

declare var serverConfig: { [id: string]: any };

@Directive({})
export class EnpsDirective extends EnpsSubscriber implements OnDestroy {

    @Input() public isNewRecord: boolean = false;

    public static uniqueIdCharacters: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    public static uniqueId(len: number) {
        let ret = "";
        for (var i = 0; i < len; i++) {
            ret += EnpsDirective.uniqueIdCharacters.charAt(Math.floor(Math.random() * EnpsDirective.uniqueIdCharacters.length));
        }
        return ret;
    }

    public referalId: string;
    public loading: boolean = false;
    public loaderTimeout;
    
    public static visualStatesCollection: { [id: string]: Object } = {}   

    public get usvSetting(): boolean {
        if (serverConfig["USV"] && serverConfig["USV"].toLowerCase() == "true") {
            return true;
        } else {
            return false;
        }
    }

    public get visualState(): Object {
        if (this._id) {
            if (!EnpsDirective.visualStatesCollection[this._id]) {
                EnpsDirective.visualStatesCollection[this._id] = {};
            }
            return EnpsDirective.visualStatesCollection[this._id];
        } else {
            return null;
        }
    }

    public set visualState(s: Object) {
        if (this._id) {
            EnpsDirective.visualStatesCollection[this._id] = s;
        }
    }

    private _id: string = null;
    @Input()
    public get id(): string {
        return this._id;
    }
    public set id(v: string) {
        if (this._id) {
            delete EnpsDirective.visualStatesCollection[this._id];
        }

        this._id = v;
        if (this._id && !EnpsDirective.visualStatesCollection[this._id]) {
            EnpsDirective.visualStatesCollection[this._id] = {};
        }
    }

    private __required: boolean;
    @Input()
    public get required(): boolean {
        return this.__required;
    }
    public set required(v: boolean) {
        this.__required = v;
    }
  
    constructor(public timeoutQueue: TimeoutQueue) {
        super();
        this.referalId = EnpsDirective.uniqueId(32);
    }

    ngOnDestroy() {
        this.removeAllSubscriptions();
        for(let p of Object.keys(this)) {
            if (
                (this[p] instanceof Record) ||
                (this[p] instanceof Subscription) ||
                (this[p] instanceof EnpsDirective) ||
                (this[p] instanceof ElementRef)
            ) {
                //console.log("set " + this.constructor.name + "." + p + " to null");
                this[p] = null;
            }
        }
        this.subscriptions = new Subscription();
    }

    public showLoader() {
        this.loaderTimeout = this.timeoutQueue.setTimeout(() => {
            this.loading = true;
        }, 200);
    }

    public hideLoader() {
      if (this.loaderTimeout) {
        this.timeoutQueue.clearTimeout(this.loaderTimeout);
      }
      this.loading = false;
    }
}
